<script>
import { createNewEod, getOneEod, updateOneEod } from '@/services/EodReviewPreviewServices';
import { getAllWinsForTodayFromDbase } from '@/services/WinsServices';
import { createBigTask, getBigTaskFromDbase } from '@/services/BigTaskServices';
import { addSmallTaskToToday, getAllSmallTasksFromDbase } from '@/services/SmallTasksServices';
import { getJournalFromDbase, updateJournal } from '@/services/JournalServices';
import Editor from '@tinymce/tinymce-vue';
import ThisWeeksTargetGoals from './ThisWeeksTargetGoals.vue';

export default {
  props: [ 'mainTargetForThisWeek' ],
  components: {
    'editor': Editor,
    ThisWeeksTargetGoals,
  },
  data() {
    return {
      allTodaysWins: null,
      winsStacked: 0,
      winsTotal: 0,
      winsNotStacked: 0,
      // =========
      ogEod: {},
      showFormEditProud: true,
      showFormEditBetter: true,
      rateYourConductDescriptions: {
        1: 'downtrodded',
        2: 'not good',
        3: 'alright',
        4: 'feelin good',
        5: 'superhero',
      },
      // editable fields
      rateYourConduct: 0,
      whatProudOf: '',
      couldDoBetter: '',
      // =========
      bigTask: null,
      smallTasks: null,
      tomorrowActualsBigTask: null,
      tomorrowActualsSmallTasks: null,
      tomorrowsSmallTasks: [],
      // =========
      showTaskAdder: false,
      bigTaskCanBeAdded: false,
      smallTasksThatCanBeAdded: [],
      // =========
      journal: null,
      // =========
      loading: true,
      iWantToJournal: false,
      todaysJournal: null,
      dateCreated: null,
      dateUpdated: null,
      brandNew: true,
      journalSavedSnackbar: false,
      journalSavedText: 'Journal saved successfully.',
      // journalSavedTimeout: 2000,
      journalSavedTimeout: 1337,
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    todayActual() { return this.$store.getters['todayActual']; },
    tomorrowActual() { return this.$store.getters['tomorrowActual']; },
  },
  watch: {
    todaysJournal: function() {
      this.$cookies.set('todaysJournal', this.todaysJournal);
    },
  },
  methods: {
    toggleFormProud() {
      this.showFormEditProud = !this.showFormEditProud;
    },
    toggleFormBetter() {
      this.showFormEditBetter = !this.showFormEditBetter;
    },
    async selectConductRating(c) {
      // build data
      let updatedEod = { ...this.ogEod };
      updatedEod.conduct = c;
      updatedEod.dateUpdated = this.todayActual;
      // make the update
      const updatedConductRatingInEod = await updateOneEod(this.uId, this.token, this.today, updatedEod);
      // if update is successful, then update the ui
      if (updatedConductRatingInEod) {
        this.ogEod = updatedEod;
        this.rateYourConduct = c;
      }
    },
    async saveProudOf() {
      // build the data
      let updatedEod = { ...this.ogEod };
      updatedEod.proud = this.whatProudOf.trim();
      updatedEod.dateUpdated = this.todayActual;
      // make the update
      const successfullyUpdatedProudStringInEod = await updateOneEod(this.uId, this.token, this.today, updatedEod);
      if (successfullyUpdatedProudStringInEod) {
        this.ogEod = { ...updatedEod };
      } else {
        this.whatProudOf = this.ogEod.proud;
      }
      this.showFormEditProud = false;
    },
    async saveDoneBetter() {
      // build the data
      let updatedEod = { ...this.ogEod };
      updatedEod.better = this.couldDoBetter.trim();
      updatedEod.dateUpdated = this.todayActual;
      // make the update
      const successfullyUpdatedBetterStringInEod = await updateOneEod(this.uId, this.token, this.today, updatedEod);
      if (successfullyUpdatedBetterStringInEod) {
        this.ogEod = { ...updatedEod };
      } else {
        this.couldDoBetter = this.ogEod.better;
      }
      this.showFormEditBetter = false;
    },
    async addBigTaskToTomorrow() {
      // if tomorrowActual doesn't have a BigTask
      if (!this.tomorrowActualsBigTask.title) {
        // API call - for tomorrowActual, using this.bigTask
        const tomBT = {
          title: this.bigTask.title,
          description: this.bigTask.description ? this.bigTask.description : '',
          stacked: false,
          dateCreated: this.todayActual,
          dateUpdated: this.todayActual,
        };
        // const addedTomorrowBigTask = await createBigTask(this.uId, this.token, this.tomorrowActual, tomBT);
        await createBigTask(this.uId, this.token, this.tomorrowActual, tomBT);
      }
      // if tomorrowActual has a BigTask, but it's different from today's BigTask
      else if (
          this.bigTask.title !== this.tomorrowActualsBigTask.title &&
          !this.tomorrowsSmallTasks.includes(this.bigTask.title)
      ) {
        // bc tomorrowActual already has a bigTask, add it as a smallTask
        const tomST = {
          task: `${this.bigTask.title} - ${this.bigTask.description}`,
          stacked: false,
          dateCreated: this.todayActual,
          dateUpdated: this.todayActual,
        };
        await addSmallTaskToToday(this.uId, this.token, this.tomorrowActual, tomST);
      }
      // UI - hide the add button
      const btn = document.getElementById('btn-add-big-task-to-tomorrow');
      const added = document.getElementById('big-task-added');
      if (btn) { btn.remove(); }
      if (added) { added.classList.remove('d-none'); }
    },
    async addSmallTaskToTomorrow(task) {
      // create newTask object
      const newSmallTask = {
        task: task.task,
        stacked: false,
        dateCreated: this.todayActual,
        dateUpdated: this.todayActual,
      };
      // API call: create the task
      await addSmallTaskToToday(this.uId, this.token, this.tomorrowActual, newSmallTask);
      // update the UI - hide the add button
      const btn = document.getElementById(`btn-add-small-task-to-tomorrow-${task.id}`);
      const added = document.getElementById(`small-task-added-${task.id}`);
      if (btn) {
        btn.remove();
      }
      if (added) {
        added.classList.remove('d-none');
      }
    },
    showTheJournal() {
      this.iWantToJournal = true;
    },
    async saveJournal() {
      const j = {
        journal: this.todaysJournal,
        dateUpdated: this.todayActual,
        dateCreated: this.brandNew ? this.todayActual : this.dateCreated,
      };
      const success = await updateJournal(this.uId, this.token, this.today, j);
      if (success) {
        this.journalSavedSnackbar = true;
      }
    },

  },
  async mounted() {
    /* INIT COUNT WINS STACKED - GET x of y WINS STACKED */
    this.allTodaysWins = await getAllWinsForTodayFromDbase(this.uId, this.token, this.today); // get allTodaysWins

    for (let win of this.allTodaysWins) {
      // count stacked wins && total wins -- MINIMUM 12 equal signs to be excluded as a spacer (reco: 25+)
      if (!win.win.includes('============')) {
        win.stacked ? this.winsStacked++ : this.winsStacked+= 0;
        this.winsTotal++;
      }
    }
    this.winsNotStacked = this.winsTotal - this.winsStacked;

    // INIT BIG TASK && SMALL TASKS
    this.bigTask = await getBigTaskFromDbase(this.uId, this.token, this.today);
    this.tomorrowActualsBigTask = await getBigTaskFromDbase(this.uId, this.token, this.tomorrowActual);
    this.smallTasks = await getAllSmallTasksFromDbase(this.uId, this.token, this.today);
    this.tomorrowActualsSmallTasks = await getAllSmallTasksFromDbase(this.uId, this.token, this.tomorrowActual);
    for (let task of this.tomorrowActualsSmallTasks) {
      this.tomorrowsSmallTasks.push(task.task);
    }

    // bigTaskCanBeAdded = false;
    // bigTask not stacked !this.bigTask.stacked
    // bigTask different from tomorrow's bigTask
    // bigTask not inside tomorrowsSmallTasks
    if (!this.bigTask.stacked && (this.bigTask.title !== this.tomorrowActualsBigTask.title) && (!this.tomorrowsSmallTasks.includes(this.bigTask.title))) {
      this.bigTaskCanBeAdded = true;
    }
    if (this.bigTask.title) {
      this.winsTotal++;
      if (this.bigTask.stacked) {
        this.winsStacked++;
      }
    }

    // smallTasksThatCanBeAdded = [];
    // tomorrow's smallTasks.task's
    // if today's SmallTask is not in tomorrow's smallTasks.tasks
    for (let task of this.smallTasks) {
      if (!task.stacked && !this.tomorrowsSmallTasks.includes(task.task)) {
        this.smallTasksThatCanBeAdded.push(task);
      }
      this.winsTotal++;
      if (task.stacked) {
        this.winsStacked++;
      }
    }

    // this.showTaskAdder = false;
    if (this.bigTaskCanBeAdded || this.smallTasksThatCanBeAdded.length) {
      this.showTaskAdder = true;
    }
    /* INIT EOD - GET EOD: rateYourConduct, whatProudOf, couldDoBetter */
    const eod = await getOneEod(this.uId, this.token, this.today);
    if (eod) {
      this.ogEod = eod;
      this.showFormEditProud = !eod.proud?.length;
      this.showFormEditBetter = !eod.better?.length;

      this.rateYourConduct = eod.conduct;
      this.whatProudOf = eod.proud;
      this.couldDoBetter = eod.better;
    } else {
      const blankEod = {
        conduct: 0,
        proud: '',
        better: '',
        dateCreated: this.todayActual,
        dateUpdated: this.todayActual,
      };
      await createNewEod(this.uId, this.token, this.today, blankEod);
    }


    /* INIT JOURNAL - GET JOURNAL */
    this.journal = await getJournalFromDbase(this.uId, this.token, this.today);
    // do journal stuff (from previous versions
    if (this.journal) {
      this.todaysJournal = this.journal.journal;
      this.dateCreated = this.journal.dateCreated;
      this.dateUpdated = this.journal.dateUpdated;
      this.brandNew = false;

      // todo: why am i getting and setting cookies here? is it for the autosave functionality? not sure.
      // if (this.$cookies.get('todaysJournal')) {
      //   if (this.todaysJournal !== this.$cookies.get('todaysJournal')) {
      //     this.todaysJournal = this.$cookies.get('todaysJournal');
      //     console.log('cookie is different');
      //   } else {
      //     console.log('cookie is same');
      //   }
      // }
      // else {
      //   this.$cookies.set('todaysJournal', this.todaysJournal);
      //   console.log('no cookie');
      // }
    }
    else {
      this.todaysJournal = '';
    }
    this.loading = false;
  },
};
</script>

<template>
  <div id="eod-report-eod-report" class="pt-2 pb-8">
    <h3 class="text-decoration-underline">Daily Review / Preview</h3>
    <p class="text-body-2 mt-1 font-italic">At the <b>End Of Day</b>, take a few minutes to <b>Review</b> how you lived today, and <b>Preview</b> your plan for tomorrow.</p>

    <ThisWeeksTargetGoals :mainTargetForThisWeek="mainTargetForThisWeek" />

    <!-- REVIEW TODAY -->
    <h2 class="mt-16 mb-2 text-center text-uppercase font-weight-black">REVIEW Today</h2>

    <!-- X OF Y WINS STACKED -->
    <div class="mt-3 text-center">
      <p class="text-decoration-underline font-weight-bold">{{ winsStacked }} of {{ winsTotal }} Wins Stacked</p>
      <div id="eod-wins-star-container">
        <v-icon v-for="i of winsStacked" :key="i"
                icon="mdi-star" color="yellow-darken-2"></v-icon>
        <v-icon v-for="i of winsNotStacked" :key="i"
              icon="mdi-star-outline" color="grey-lighten-1"></v-icon>
      </div>
    </div>

    <!-- RATE YOUR CONDUCT -->
    <div class="mt-8">
      <p class="text-decoration-underline font-weight-bold">Rate your overall conduct today</p>
      <div class="d-flex justify-space-between mt-2">
        <div v-for="i in 5" :key="i"
             class="conduct-rating-one-of-five d-flex flex-column align-center justify-start"
        >
          <v-icon @click.prevent="selectConductRating(i)"
                  :icon="rateYourConduct >= i ? 'mdi-arm-flex' : 'mdi-arm-flex-outline'"
                  :color="rateYourConduct >= i ? 'yellow-darken-2' : 'grey-lighten-1'"
          ></v-icon>
          <p class="rate-your-conduct-descriptions text-wrap">{{ rateYourConductDescriptions[i] }}</p>
        </div>
      </div>

    </div>

    <!-- PROUD OF TODAY -->
    <div class="mt-10">
      <p class="text-decoration-underline font-weight-bold">What are you proud of accomplishing today?</p>

      <div v-if="!showFormEditProud">
        <p class="allow-pre-line">{{ ogEod.proud }}</p>
        <p class="text-body-2 text-right font-italic text-red-lighten-3">
          <span @click.prevent="toggleFormProud" class="toggle-eod-edit">Edit</span>
        </p>
      </div>

      <div v-else>
        <v-textarea v-model="whatProudOf" id="proud-of-input"
                    variant="outlined"
                    rows="2" auto-grow
        ></v-textarea>
        <div class="d-flex justify-end" style="margin-top: -20px;">
          <v-btn @click.prevent="saveProudOf"
                 density="compact"
                 class="text-capitalize px-0"
                 :class="whatProudOf ? 'bg-blue-lighten-3' : ''"
                 :disabled="!whatProudOf"
          >Save</v-btn>
        </div>
      </div>
    </div>

    <!-- COULD DO BETTER -->
    <div class="mt-8">
      <p class="text-decoration-underline font-weight-bold">What could you have done better today?</p>

      <div v-if="!showFormEditBetter">
        <p class="allow-pre-line">{{ ogEod.better }}</p>
        <p class="text-body-2 text-right font-italic text-red-lighten-3">
          <span @click.prevent="toggleFormBetter" class="toggle-eod-edit">Edit</span>
        </p>
      </div>

      <div v-else>
        <v-textarea v-model="couldDoBetter" id="could-do-better-input"
                    variant="outlined"
                    rows="2" auto-grow
        ></v-textarea>
        <div class="d-flex justify-end" style="margin-top: -20px;">
          <v-btn @click.prevent="saveDoneBetter"
                 density="compact"
                 class="text-capitalize px-0"
                 :class="couldDoBetter ? 'bg-blue-lighten-3' : ''"
                 :disabled="!couldDoBetter"
          >Save</v-btn>
        </div>
      </div>

    </div>

    <hr class="mt-8" />


    <!-- PREVIEW TOMORROW -->
    <h2 class="mt-16 text-center font-weight-black">PREVIEW Tomorrow</h2>

    <div class="mt-2 d-flex justify-space-between">
      <p class="text-body-2 pe-2 font-italic font-weight-bold">Formulate your plan: what do you need/want to accomplish tomorrow?</p>
      <router-link :to="`/dash/${tomorrowActual}`" class="text-right text-body-2 text-red-lighten-2"><i>Go to tomorrow's dashboard</i></router-link>
    </div>

    <!-- ADD UNFINISHED TASKS TO TOMORROW -->
    <div v-if="showTaskAdder" id="add-big-task-to-tomorrow" class="mt-10">

      <p class="text-decoration-underline font-weight-bold">Today's Unfinished Tasks - Add to tomorrow</p>

      <div class="border rounded pb-3 px-2 bg-red-lighten-4">

        <p class="text-right text-body-2 text-grey-darken-1 font-italic mb-3">(add to {{tomorrowActual}})</p>

        <!-- BIG TASK -->
        <div v-if="bigTaskCanBeAdded"
          id="add-big-task-to-tomorrow"
          class="d-flex align-start justify-space-between mt-1"
        >
          <p class="allow-pre-line">
            <b>Big Task: {{bigTask.title}}</b><br />
            <span class="text-body-2">{{bigTask.description}}</span>
          </p>
          <v-btn @click.prevent="addBigTaskToTomorrow" id="btn-add-big-task-to-tomorrow"
                 density="compact"
                 variant="text"
          ><v-icon>mdi-calendar-plus</v-icon></v-btn>
          <p id="big-task-added" class="d-none font-italic text-body-2 text-green-lighten-2">Added</p>
        </div>

        <!-- Small Tasks -->
        <div v-if="smallTasksThatCanBeAdded.length" id="add-small-tasks-to-tomorrow">
          <div v-for="task of smallTasks" :key="task.id">
            <div v-if="!task.stacked" class="d-flex align-center justify-space-between mt-6">
              <p class="allow-pre-line"><b>{{task.task}}</b></p>
              <v-btn @click.prevent="addSmallTaskToTomorrow(task)" :id="`btn-add-small-task-to-tomorrow-${task.id}`"
                     density="compact" variant="text"
                     class="btn-add-small-task-to-tomorrow"
              ><v-icon>mdi-calendar-plus</v-icon></v-btn>
              <p :id="`small-task-added-${task.id}`" class="d-none font-italic text-body-2 text-green-lighten-2">Added</p>
            </div>
          </div>
        </div>
      </div>

    </div>



    <!-- JOURNAL SECTION -->
    <h3 class="mt-10 mb-2 text-decoration-underline">WRITE in my Journal</h3>

    <!-- show journal loading circle -->
    <div v-if="loading">
      <v-progress-circular :size="100" color="amber" indeterminate></v-progress-circular>
    </div>

    <!-- hide journal loading circle -->
    <div v-else class="pb-4">

      <!-- journal preview -->
      <div v-if="!iWantToJournal">
        <div v-if="todaysJournal.length" v-html="todaysJournal" class="allow-pre-line mb-4 pa-4 border bg-grey-lighten-5"></div>
        <v-btn class="ms-12 btn-show-journal" @click.prevent="showTheJournal">Open Journal</v-btn>
      </div>

      <!-- journal opened (RTE) -->
      <div v-else>
        <v-snackbar v-model="journalSavedSnackbar"
                    :timeout="journalSavedTimeout"
                    color="blue"
        >{{ journalSavedText }}</v-snackbar>
        <editor v-model="todaysJournal" id="todays-journal"
                api-key="5g5urfy4wful0409hcapzw1vzuw82djwy0sq1ntob7eyjc51"
                cloud-channel="6"
                :init= "{ selector: '#todays-journal', height: 400, }"
                plugins="link lists wordcount"
                toolbar="bold italic underline strikethrough numlist bullist link alignleft aligncenter alignright wordcount"
        />
        <div class="d-flex justify-end">
          <v-btn @click.prevent="saveJournal" color="green" class="my-5">Save</v-btn>
        </div>
      </div>

    </div>
    <hr class="mt-8" />


  </div>
</template>

<style lang="scss" scoped>
hr { border-top: 3px dotted #999; }
.allow-pre-line { white-space: pre-line; }

#eod-wins-star-container {
  max-width: 300px;
  margin: 0 auto;
}
.conduct-rating-one-of-five {
  width: 20%;
  i:hover,
  p:hover {
    cursor: pointer;
  }
}
.rate-your-conduct-descriptions {
  font-size: 10px;
}

.toggle-eod-edit:hover {
  cursor: pointer;
}

#btn-add-big-task-to-tomorrow,
.btn-add-small-task-to-tomorrow {
  margin-right: -24px;
  margin-left: -16px;
}

.btn-show-journal {
  background-color: gold;
  color: black;
  border: 1px solid black;
}

</style>
